import { useState, type FormEvent } from 'react';

interface Props {
  onLogin: (password: string) => Promise<void>;
}

export function LoginGate({ onLogin }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await onLogin(password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <div className="scanlines" aria-hidden />
      <div className="vignette" aria-hidden />
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <span className="logo">
            <span className="logo__mark">◈</span> INTEL
          </span>
          <p className="login__tag">PHONE NUMBER INTELLIGENCE // ACCESS CONTROL</p>
        </div>
        <label className="login__label" htmlFor="pw">
          AUTH_PASSWORD
        </label>
        <div className="login__field">
          <span className="login__prefix">KEY</span>
          <input
            id="pw"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••••••"
          />
        </div>
        {error && <p className="login__err">{error}</p>}
        <button className="btn btn--primary" type="submit" disabled={busy || !password}>
          {busy ? 'AUTHENTICATING…' : 'ENGAGE'}
        </button>
        <p className="login__hint">
          API: <code>Authorization: Bearer &lt;password&gt;</code>
        </p>
      </form>
    </div>
  );
}
